import React from 'react'
import { useOutletContext } from 'react-router-dom'

import WizardContainer from './shared/WizardContainer'
import Users from '../settings/Users'

const InviteUsers = () => {
  const { navigateToNext, wizardState, updateWizardState } = useOutletContext()

  return (
    <WizardContainer sx={{ width: '750px' }}>
      <Users
        state={wizardState}
        updateState={updateWizardState}
        wizardFooterProps={{
          primaryButton: {
            label: 'Save and Continue',
            onClick: navigateToNext,
          },
        }}
      ></Users>
    </WizardContainer>
  )
}

export default InviteUsers
